/* CONSTANTS & VARIABLES ----------------------------------------------------------------------------------------------------------- */
/* LISTENERS ----------------------------------------------------------------------------------------------------------------------- */


  $(document).ready(() => {

    // on form input remove error class if new input is valid
    document.querySelectorAll('input, select, textarea').forEach(input => {
      input.addEventListener('input', (e) => {
        if (e.target.checkValidity()) e.target.classList.remove('error');
      });
    });
    
  });

/* FUNCTIONS ----------------------------------------------------------------------------------------------------------------------- */

  function isAfterRentalCutoff(pickupPrefix = "") {
    const now = new Date();
    const sfTime = new Date(now.toLocaleString("en-US", { timeZone: "America/Los_Angeles" }));
    const hours = sfTime.getHours();
    return hours >= 17;
  }

  function dateIsToday(date) {
    const today = new Date(new Date().toLocaleString("en-US", { timeZone: "America/Los_Angeles" })).toISOString().split('T')[0];
    if (date === today) return true;
    return false;
  }

  function animateAddToBagButton(button) {
    if (!button.hasClass('relative')) button.addClass('relative');
    const placeholder = $(`<div class="btn added-bubbling absolute top-0 left-0 right-0 sb-green w-full flex flex-wrap items-center justify-center text-lg font-semibold mx-auto gap-2"><i class="sb-icon-check text-white"></i>Added</div>`);
    button.append(placeholder);
    setTimeout(() => { placeholder.remove() }, 2000);
  }

  function updateCartCountDisplay() {
    getCart().then(cart => {  
      const cartCount = cart.item_count;
      document.querySelectorAll('[data-cart-count]').forEach(el => {
        el.dataset.cartCount = cartCount;
        el.textContent = cartCount ;
      })
    });
    bagCountAnimation();
  } 


  function getProductHandleFromURL(url) {
    url  = url || window.location.href;
    const urlObj = new URL(url);
    const pathSegments = urlObj.pathname.split('/');
    const productIndex = pathSegments.indexOf('products');
    if (productIndex !== -1 && productIndex + 1 < pathSegments.length) return pathSegments[productIndex + 1];
    return null;
  }

  async function getProductJson(handle) {
    try {
      const response = await fetch(`/products/${handle}.json`);
      const data = await response.json();
      return data.product;
    } catch (error) {
      console.error('Error fetching product data:', error);
      return null;
    }
  }

  async function getAvailableStores(article) {
    const apiUrl = "https://inventory.sportsbasement.com/availableStores"
    const storesData = stores.map(({ name, short_name, store_prefix: abbreviation }) => ({ name, short_name, abbreviation }));
    try {
      if(!article || !storesData) return null;
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ article: article, stores: storesData }),
      });
      const data = await response.json(); // Parse JSON response
      const availableStores = data.filter(store => store.available).map(store => store.name);
      return availableStores;
    } catch (error) {
      console.error('Error fetching store inventory data:', error);
      return null;
    }
  }

  async function getStoreAvailability(article) {
    const apiUrl = "https://inventory.sportsbasement.com/availableStores_v2"
    const storesData = stores.map(({ name, short_name, store_prefix: abbreviation }) => ({ name, short_name, abbreviation }));
    try {
      if(!article || !storesData) return null;
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ article: article, stores: storesData }),
      });
      const data = await response.json(); // Parse JSON response
      console.log('availableStores_v2', data)
      return data;
    } catch (error) {
      console.error('Error fetching store inventory data:', error);
      return null;
    }
  }



  function bagCountAnimation() {
    const cartCountBubbles = document.querySelectorAll('.cart-count');
    if (!cartCountBubbles) return;
    cartCountBubbles.forEach(bubble => {
      bubble.classList.remove('bubbling');
      bubble.classList.add('bubbling');
      bubble.addEventListener('animationend', () => {
        bubble.classList.remove('bubbling');
      });
    });
  }

  async function getCart() {
    return fetch('/cart.js').then(response => response.json());
  }

/* USER DELIVERY PREFERNCES -------------------------------------------------------------------------------------------------------- */
  const fetchUserPreferences = () => {
    const data = JSON.parse(localStorage.getItem("sb-user-preferences")) || {
      deliveryMethod: null,
      store: {
        name: null,
        storePrefix: null,
        erBranchId: null,
      },
      zipcode: null,
    };
    return data; 
  }

  let userPreferences = fetchUserPreferences();
  // bfcache: when the user navigates back, re-sync from localStorage
  window.addEventListener("pageshow", (event) => {
    if (event.persisted) {
      userPreferences = fetchUserPreferences();
      updateUserPrefrencesDataAttributes();
    }
  });
  
  const updateUserPrefrencesDataAttributes = () => {
    const preferences = fetchUserPreferences();
    // set method data attributes
    const deliveryMethodElements = document.querySelectorAll('[data-selected-method]') || [];
    deliveryMethodElements.forEach((el) => el.dataset.selectedMethod = preferences?.deliveryMethod || '');
    // set store data attributes
    const pickupStoreElements = document.querySelectorAll('[data-selected-store]') || [];
    pickupStoreElements.forEach((el) => el.dataset.selectedStore = preferences?.store?.name || '');
    document.querySelector(`#search-in-store-pickup-stores [name="secondary-selector--store"][value="${preferences?.store?.name}"]`).checked = true;
  }



/* EVERYTHING BELOW NEEDS CLEAN UP vvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvv */
/*============================*/
/* Update main product image. */
/*============================*/
  var switchImage = function(newImageSrc, newImage, mainImageDomEl) {
    // newImageSrc is the path of the new image in the same size as originalImage is sized.
    // newImage is Shopify's object representation of the new image, with various attributes, such as scr, id, position.
    // mainImageDomEl is the passed domElement, which has not yet been manipulated. Let's manipulate it now.
    if(newImageSrc && mainImageDomEl) {
      jQuery(mainImageDomEl).parents('a').attr('href', newImageSrc.replace('_large', '_1024x1024'));
      jQuery(mainImageDomEl).attr('src', newImageSrc);

      const newSrcsets = [
        newImageSrc.replace('_large', '_180x180'),
        newImageSrc.replace('_large', '_280x280'),
        newImageSrc.replace('_large', '_320x320'),
        newImageSrc.replace('_large', '_400x400'),
        newImageSrc.replace('_large', '_grande')
      ];

      $('#product-picture source').each(function(index) {
        $(this).attr('srcset', newSrcsets[index]);
      });
    }
  };

  $(document).ready(() => {

    // hide footer until document is ready
    $('#global-footer').removeClass('hidden');
  
    // When our page loads, check to see if it contains and anchor
    scroll_if_anchor(window.location.hash);

    // Smooth scrolling to anchor tags
    $(document).on('click', 'a[href^="#"]:not(".hashlink")', function (event) {
      event.preventDefault();
      $('html, body').animate({
        scrollTop: $($.attr(this, 'href')).offset().top - 175
      }, 500);
    });

    // Mobile filter toggle
    $(document).on('click', '.toggle-filters:not(".hashlink")', function (event) {
      $("#mobile-filters").slideToggle();
      $(".mobile-filters-plus-minus").toggle();
    });

    // Mobile cart button
    $(document).on('click', '#add', function (event) {
      $('#mobile-cart-button').removeClass('hidden');
    });

    // responsive embeded videos
    $('iframe[src*="youtube.com/embed"]').wrap('<div class="video-wrapper"></div>');
    $('iframe[src*="player.vimeo"]').wrap('<div class="video-wrapper"></div>');
  
    // embeded maps
    $('.embed-container.map').click(function () {
      $('.embed-container.map iframe').css("pointer-events", "auto");
    });

    $( ".maps" ).mouseleave(function() {
      $('.embed-container.map iframe').css("pointer-events", "none"); 
    });
  
    // SBO Xola Buttons
    $('.xola-checkout').addClass('btn sb-green');
    $('.xola-gift').addClass('btn primary outline');
  
    // check for cart rentals on load
    checkForCartRentals();

    // remove rental items from cart on user request
    $('.removeRentalItemsFromCart').on('click tap', function() {
      removeRentalItemsFromCart();
    });

    // listen for cart updates
    // const open = window.XMLHttpRequest.prototype.open;
    // window.XMLHttpRequest.prototype.open = openReplacement;

    // collapser
    let allCollapsed = false;
    $(".collapser").on("click", function(){
      // get variables
      let collapsee = $(this).data("collapsee");
      let group = $(collapsee).data("collapse-group");
      let delay;
      group ? delay = 650 : delay = 0;

      if (!$(this).hasClass('collapsed')) {
        $(this).addClass("collapsed");
        $(collapsee).slideUp();
        allCollapsed = true;
      } else {
        // if group collapse rest of group
        if(group) {
          $(`.collapser:not([data-collapsee="${collapsee}"])`).addClass("collapsed");
          $(`*[data-collapse-group="${group}"]:not(${collapsee})`).slideUp();
        }
        // toggle target
        allCollapsed ? $(collapsee).slideDown(500) : $(collapsee).delay(delay).slideDown(500);
        $(this).removeClass("collapsed");
        allCollapsed = false;
      }
    });

    /* SBO LISTENERS --------------------------------------------------------------------------------------------------------------------- */
      // tooltip mouseover
      $('.hasTooltip').on('mouseover', function() {
        let target = $(this).data('tooltip-target');
        $(target).addClass('active');
      });

      // tooltip mouseout
      $('.hasTooltip').on('mouseout', function() {
        let target = $(this).data('tooltip-target');
        $(target).removeClass('active');
      });

      // scrollr
      $('.scrollr').each(function(){
        // $(this).parent().append('<div class="scrollr-bar"><div class="scrollr-bar-indicator"></div></div>')
        let scrollrCount = this.children.length
        $(this).parent().append('<div class="scrollr-prev">‹</div><div class="scrollr-next">›</div>');
        $(this).attr('data-position', '0').attr('data-children',scrollrCount);
      });
    
      $('.scrollr-prev').click(function(){
        let scrollr = $(this).siblings('.scrollr');
        let scrollrId = ('#' + scrollr[0].id);
        $(scrollrId).animate({
          scrollLeft: '-=' + scrollr[0].clientWidth
        }, 500);
      });
      
      $('.scrollr-next').click(function(){
        let scrollr = $(this).siblings('.scrollr');
        let scrollrId = ('#' + scrollr[0].id);
        $(scrollrId).animate({
          scrollLeft: '+=' + scrollr[0].clientWidth
        }, 500);
      });
  });



/* FUNCTIONS >> General ------------------------------------------------------------------------------------------------------------------------------ */

  // turn string into Shopify handle
  function handleize(text) {
    return text?.toString().toLowerCase()
      .replace(/\s+/g, '-')           // Replace spaces with -
      .replace(/[^\w\-]+/g, '-')      // Replace all non-word chars with -
      .replace(/\-\-+/g, '-')         // Replace multiple - with single -
      .replace(/^-+/, '')             // Trim - from start of text
      .replace(/-+$/, '');            // Trim - from end of text
  }

  function scroll_if_anchor(href) {
    href = typeof(href) == "string" ? href : $(this).attr("href");
  
    // If href missing, ignore
    if(!href) return;
  
    // You could easily calculate this dynamically if you prefer
    var fromTop = 175;
    
    // If our Href points to a valid, non-empty anchor, and is on the same page (e.g. #foo)
    // Legacy jQuery and IE7 may have issues: https://stackoverflow.com/q/1593174
    if(href.charAt(0) == "#") {
      var $target = $(href);
  
      // Older browsers without pushState might flicker here, as they momentarily
      // jump to the wrong position (IE < 10)
      if($target.length) {
        $('html, body').animate({ scrollTop: $target.offset().top - fromTop });
        if(history && "pushState" in history) {
          history.pushState({}, document.title, window.location.pathname + href);
          return false;
        }
      }
    }
  }

  async function fetchCart() {
    try {
      const response = await fetch('/cart.js');
      if (!response.ok) throw new Error('Shopify cart.js response was not ok', response);
      const cart = await response.json();
      return cart;
    } catch (error) {
      console.error('Unable to fetch cart:', error);
    }
  }


  function updateCartCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const cartCountElement = document.querySelector('.cart-count');
        cartCountElement.classList.toggle('hidden', cart.item_count === 0);
      });
  }

  function openReplacement() {
    this.addEventListener("load", function () {
      if (
        [
          "/cart/add.js",
          "/cart/update.js",
          "/cart/change.js",
          "/cart/clear.js"
        ].includes(this._url)
      ) {
        checkForCartRentals();
        updateCartCount();
      }
    });
    return open.apply(this, arguments);
  }

/* FUNCTIONS >> Products ----------------------------------------------------------------------------------------------------------------------------- */


/* FUNCTIONS >> Rentals manipulation in cart --------------------------------------------------------------------------------------------------------- */

  async function getCartProductVendor(item) {
    const a = item.children('.image').children()
    if(a.length === 0) return
    const href = a[0].href,
      route = '/products/',
      handle = href.split(route)[1].split('?')[0],
      query = route + handle + '.js';
    
    let vendor;
    await jQuery.getJSON(query).then((product) => {
      vendor = product.vendor.toLowerCase();
    });
    return vendor;
  }
  
  function checkForCartRentals(){
    var cartHasRentalAttributes = false;
    var cartHasRentals = false;
    jQuery.getJSON('/cart.js', function(cart) {
       
      // check for rental cart attributes
      if (cart.attributes.rLength || cart.attributes.rStart || cart.attributes.rEnd) { 
        cartHasRentalAttributes = true; 
      }
      
      // check for rental products in cart
      $.each(cart.items, function(index, item) { 
        if (item.vendor === 'SB Rentals') { 
          cartHasRentals = true;
          $('#pickupDate').text(cart.attributes.Pickup);
          $('#returnDate').text(cart.attributes.Return);
          $('#rentalPeriodOverlay').fadeIn(500);
          return false;
        } 
      });
      
    }).promise().done(function(){
      if(!cartHasRentals && cartHasRentalAttributes) { removeRentalAttributesFromCart(); } // clear rental cart attributes
    });
  }

  Date.prototype.addDays = function(days) {
    this.setDate(this.getDate() + parseInt(days));
    return this;
  };


  function scrollToElementWithOffset(element, offset = 200) {
    if (!element) return;
    const rect = element.getBoundingClientRect();
    const isOutOfView = rect.top < 0 || rect.bottom > window.innerHeight;
    if (isOutOfView) {
        const targetScroll = window.scrollY + rect.top - offset;
        window.scrollTo({ top: targetScroll, behavior: "smooth" });
    }
  }


